import { useGateValue } from '@statsig/react-bindings';

type FeatureGate = 'directory_area_page_v2' | 'directory_branch_page_v2';

const useGate = (gate: FeatureGate): boolean => useGateValue(gate);

export default useGate;
